import { BundleType } from "../models";

export const bundleTypeTextMap = {
  [BundleType.CLASS]: 'COMMON.class',
  [BundleType.COURSE]: 'COMMON.course',
  [BundleType.MODULE]: 'COMMON.module',
  [BundleType.LESSON]: 'COMMON.lesson',
  [BundleType.QUIZ]: 'CHAPTERS.quiz',
  [BundleType.LIBRARY]: 'COMMON.library',
  [BundleType.WEBINAR]: 'COMMON.webinar',
  [BundleType.IN_PERSON]: 'COMMON.in_person_event',
  [BundleType.USER]: 'COMMON.users',
  [BundleType.CONTENT_GROUP]: 'COMMON.group',
  [BundleType.ASSIGNMENT]: 'COMMON.quiz',
  [BundleType.EVENT]: 'COMMON.event',
  [BundleType.LEARNING_PATH]: 'LEARNING_PATH.learning_path',
}